import '@/assets/style/createCompany.scss';
import {
  Card,
  Checkbox,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
} from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePostApi } from '@/apiError/apiCreate';
import { ShowAllData, useGetApiListNoToast } from '@/apiError/apiShow';
import { ShowDataById } from '@/apiError/apiShowById';
import { useUpdateApi } from '@/apiError/apiUpdate';
import { useTransactionContext } from '@/context/TransactionContext';
import { getTodaysDate, getTodaysDateMYD } from '@/utils/date/TodaysDate';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { Back } from '@/utils/routerPath/NavigationHelper';
import {
  TransactionPurchaseTableHeaderOld as columns,
  SALES_ORDER_COLUMNS_NEW,
  TransactionBillColumns,
} from '@/utils/tableHeader';
import dayjs from 'dayjs';
import DynamicTransactionHeader from '../reuse/DynamicHeader';
import {
  handleVoucherFetchApiClicked,
  processTransactionData,
  renderTransactionTableSummary,
  renderTransactionTableSummarySalesI,
  transactionSubmitNewImage,
  updateCodeWindowJson,
  useBarcodeModal,
} from '../reuse/DynamicTransactionFunctions';
import SalesReceiptModal from '../sales/SalesReceiptModal';
import { VoucherFooterButton } from '@/pages/vouchers/VoucherComponent';
import TransactionSubmitModal from '@/utils/modal/TransactionSubmitModal';
import { getBsFromAD } from '@/utils/helpers/getTodayDate';
import { AntButton } from '@/common/ant-components/AntButton';
import { useNavigationHistory } from '@/common/navigation-history';
import { returnLinks } from '@/common/navigation-history/data';
import DraggableModal from '@/common/ant-components/DraggableModal';
import DynamicTransactionTableDisabled from '../reuse/DyanamicTransactionTableDisabled';
import DynamicTransactionTableSO from '../reuse/DyanamicTransactionTableSalesOrder';
import QuickPurchase from '../purchase-with-modal/QuickPurchase';
import { useSelector } from 'react-redux';
import { warningTitle } from '@/common/custom-date-selector-list/helpers';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useDeviceInfo from '@/theme/device-info';
import { formatNumberWithComma } from '@/utils/formula/CodeWindow';
import {
  calculateSalesAmountsWithTaxVat,
  calculateTotal,
  roundTo3,
  toDecimal,
} from '../purchase/helpers';
import Decimal from 'decimal.js';

/**
 * SalesQuotation component handles the creation and management of sales orders.
 * @returns {JSX.Element} The SalesQuotation component.
 */
const SalesQuotation = () => {
  const {
    setGlobalDividerTitle,
    setPreviousPath,
    selectedData,
    selectedDataSo,
    setSelectedDataSo,
    setReceiveFromPartyNetAmount,
    receiveTableData,
    setSalesOrderSelectedData,
    salesOrderSelectedData,
    onSalesOrderTableDataChange,
    purchaseTableData,
    salesOrderTableData,
    setHiddenValueChange,
    setSalesOrderTableData,
    editApiBlock,
    purchaseFinalJson,
    setShowSalesDescription,
    setPrefixResponse,
    setSelectedItems,
    setEditApiBlock,
    purchaseNetAmount,
    setPurchaseNetAmount,
    receiptTotalAmt,
    setReceiptTotalAmt,
    record,
    isCancel,
    setRecord,
    modalPurchase,
    setModalPurchase,
    setFrom,
    dataSource,
    setDataSource,
    paymentVoucherTotal,
    setPaymentVoucherTotal,
    setReceiptVoucherHeader,
    receiptVoucherHeader,
    taxVat,
    setTaxVat,
    groupIds,
    categoryIds,
  } = useTransactionContext();

  const {
    barcodeValue,
    barCodeVisible,
    openBarCodeModal,
    closeBarCodeModal,
    filterColumnforBillPrint,
    extraDetails,
    setExtraDetails,
  } = useBarcodeModal(salesOrderTableData, TransactionBillColumns, {
    navigatePath: '/transaction/quotation/list/',
  });

  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [codeInputs, setCodeInputs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showItemList, setShowItemList] = useState();
  const [showPartyList, setShowPartyList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [receiveModalVisible, setReceiveModalVisible] = useState(false);
  const [billNumber, setBillNumber] = useState({});
  const [cashBankLedgerData, setCashBankLedgerData] = useState([]);

  const discountRef = useRef([]);

  const [addRow, selectAddRow] = useState(null);

  const buttonRef = useRef(null);

  const updateData = useUpdateApi();

  const { confirm } = Modal;

  const { mutateAsync, isPending } = usePostApi({
    url: '/transaction/quotation/',
  });

  const { data } = useGetApiListNoToast(
    '/transaction/bill-setup/transaction-type/quotation/',
    {
      params: {
        q: '',
      },
    },
  );

  const defaultTemplateToPrint = data?.data?.find(
    (item) => item?.editorConfig?.printPreference?.is_default_format === true,
  );

  const params = useParams();

  /**
   * Handles input changes and updates the selected data state.
   * @param {string} fieldName - The name of the field being updated.
   * @param {any} value - The new value of the field.
   * @param {object} option - Additional options for the field.
   */
  const hanldeInputData = (fieldName, value, option) => {
    setSelectedDataSo((prev) => ({
      ...prev,
      [fieldName]: value,
      ...(fieldName === 'ledger' && { ledgerName: option }),
    }));
    setSalesOrderSelectedData((prev) => ({
      ...prev,
      [fieldName]: value,
      ...(fieldName === 'ledger' && { ledgerName: option }),
    }));
  };

  /**
   * Submits the sales order data.
   */

  const isActiveFinancialYear = useSelector(
    (state) => state?.financialData?.data?.isActive,
  );
  const app = useSelector((state) => state?.financialData?.data);

  const handleSubmit = async (values) => {
    if (!isActiveFinancialYear) {
      confirm({
        title: `${warningTitle}  (${app?.financialYearStartDate} to ${app?.financialYearEndDate})?`,
        icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
        onOk: async () => {
          await proceedSubmit(values);
        },
      });
      return;
    }
    await proceedSubmit(values);
  };

  const proceedSubmit = async () => {
    const entryDate = form.getFieldValue('entryDate');

    const dateToSend = entryDate ? entryDate?.format('YYYY-MM-DD') : null;

    const deliveryDate = selectedDataSo?.deliveryDate
      ? selectedDataSo?.deliveryDate?.format('YYYY-MM-DD')
      : null;

    const quotationJson = {
      billNo: selectedDataSo?.billNo || selectedDataSo?.billNumber,
      quotationDate: dateToSend,
      entryNo: selectedDataSo?.entryNumber,
      ledgerId: selectedDataSo?.ledger,
      deliveryDate: deliveryDate,
      remarks: form?.getFieldValue('remarks'),
      agentId: selectedDataSo?.agentId,
      isTaxIncluded: taxVat?.isTaxApplicable,
      discountAmount:
        form.getFieldValue('discount_amount') ||
        salesOrderSelectedData?.discountAmount ||
        0,
      ...(selectedDataSo?.storeId && {
        storeId: selectedDataSo?.storeId,
      }),
    };

    const cleanedDataSource = dataSource?.map(({ sno, key, ...rest }) => rest);

    const filteredData = salesOrderTableData.filter(
      (item) => (item?.itemId && item?.itemCode) || item?.grossWeight,
    );

    const updateCodeWindowJsonResult = updateCodeWindowJson(filteredData);

    const finalQuotationJson = {
      ...quotationJson,
      orderDate: dateToSend,

      itemDetails: updateCodeWindowJsonResult?.itemDetails?.map((item) => {
        const { images, fileList, ...rest } = item;
        return rest;
      }),
    };

    try {
      setLoading(true);
      if (id) {
        await updateData
          .mutateAsync({
            url: `/transaction/quotation/${id}/`,
            values: finalQuotationJson,
          })
          .then((res) => {
            setExtraDetails(res?.data);
          });
      } else {
        await mutateAsync(finalQuotationJson).then((res) => {
          setExtraDetails(res?.data);
        });
      }
      openBarCodeModal();
    } finally {
      setLoading(false);
    }
  };

  /**
   * Adds a new row to the purchase table data.
   */

  const handleAddRow = () => {
    onSalesOrderTableDataChange({ new: true, id: Date.now()?.toString() });
  };

  const handleItemSelect = async (value, rowIndex, itemName) => {
    handleAddRow();
    setRecord({
      value,
      index: rowIndex,
      itemName,
    });

    const uniqueId = `id-${Date.now()}`;
    selectAddRow(uniqueId);

    const updatedCodeInputs = [...codeInputs];
    const prefixResponse = await ShowAllData?.showDetails(
      `transaction/order-items/latest-code/?itemId=${value}`,
    );
    setPrefixResponse(prefixResponse?.data);

    updatedCodeInputs[rowIndex] = prefixResponse?.data?.itemCode;
    setCodeInputs(updatedCodeInputs);
    setSelectedDataSo((prevData) => ({
      ...prevData,
      item: value,
      code: [...(prevData.code || []), updatedCodeInputs],
      itemName: [...(prevData.itemName || []), itemName],
    }));

    setSalesOrderSelectedData((prevData) => ({
      ...prevData,
      item: value,
      code: [...(prevData.code || []), updatedCodeInputs],
      itemName: [...(prevData.itemName || []), itemName],
    }));

    setSalesOrderTableData((prevData) => {
      const newData = [...prevData];
      const numberOfMatches =
        prevData?.filter(
          (item) => item?.finalData?.detailsJson[0]?.itemId === value,
        )?.length || 0;
      const baseCode = updatedCodeInputs[rowIndex];
      let updatedCode = baseCode;
      const match = baseCode?.match(/^([A-Z]+)(\d+)(-.*)$/);

      if (match) {
        const [, prefix, numberStr, suffix] = match;
        const incrementedCode = numberOfMatches
          ? parseInt(numberStr) + numberOfMatches
          : numberStr;
        updatedCode = `${prefix}${String(incrementedCode).padStart(3, '0')}${suffix}`;
      }

      newData[rowIndex] = {
        ...newData[rowIndex],
        itemName: itemName,
        item: value,
        itemType: newData?.itemType || prefixResponse?.data?.itemType,
        code: updatedCode,
      };

      return newData;
    });
  };

  /**
   * Handles the deletion of a row in the purchase table.
   * @param {string} rowId - The ID of the row to delete.
   */
  const handleSalesOrderItemClicked = (
    rowId,
    rowItem,
    setIsMessageModalVisible,
  ) => {
    const isLastRow = salesOrderTableData?.length === 1;
    if (isLastRow) {
      onSalesOrderTableDataChange({ clearContent: true, id: rowId });
      setSelectedDataSo({
        ...selectedDataSo,
        itemName: '',
        code: '',
      });
      setSalesOrderSelectedData({
        ...salesOrderSelectedData,
        itemName: '',
        code: '',
      });
    } else {
      onSalesOrderTableDataChange({ delete: true, id: rowId });
    }
    setSelectedItems((prevSelected) =>
      prevSelected.filter((item) => item !== rowItem),
    );
    setIsMessageModalVisible(false);
  };

  const totalAmount = salesOrderTableData?.reduce(
    (accumulator, currentValue) => {
      let amountToAdd = currentValue?.netAmount;

      // Convert string values containing non-numeric characters
      if (typeof amountToAdd === 'string') {
        amountToAdd = amountToAdd.replace(/[^0-9.]/g, '').trim(); // Remove non-numeric characters
      }

      const numericValue = parseFloat(amountToAdd); // Convert to number

      // Only add valid numeric values
      return accumulator + (isNaN(numericValue) ? 0 : numericValue);
    },
    0,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id && !editApiBlock) {
          const response = await ShowDataById.getDataById(
            `/transaction/quotation/${id}/`,
            navigate,
          );
          setTaxVat({
            ...taxVat,
            isTaxApplicable:
              response?.data?.summaryData?.isTaxIncluded || false,
          });

          const modifiedResponse = response?.data?.detailsData?.map((item) => {
            const itemType = item?.itemTypeName;
            const newNetAmount = Number(item?.subTotal || 0);
            const taxableAmount =
              item?.taxableAmount ||
              0 -
                Number(item?.purchaseAmount || 0) -
                Number(item?.discountAmount || 0);
            const luxuryTaxAmount = item?.luxuryTaxAmount || 0;

            const isDiamondStonesJson = item?.diamondStones?.length > 0;

            return {
              ...item,
              taxPercent:
                itemType && itemType?.toLowerCase() !== 'silver'
                  ? Number(app?.luxuryTaxPercent || 0) / 100 || 0
                  : itemType?.toLowerCase() === 'silver' &&
                      Number(newNetAmount) >
                        Number(app?.silverThresholdAmount || 0)
                    ? Number(app?.luxuryTaxPercent || 0) / 100 || 0
                    : 0,

              netAmount: newNetAmount || 0,
              vatPercent:
                isDiamondStonesJson && app?.isVatApplicable
                  ? Number(app?.vatPercent || 0) / 100 || 0
                  : 0,
              netAmountWithTax: taxableAmount + luxuryTaxAmount,
            };
          });

          setPreviousPath(`/sales/quotation/edit/${id}`);
          setSalesOrderTableData([
            ...modifiedResponse,
            {
              id: Date.now().toString(),
              item: '',
              code: '',
              gwt: '',
              dsWt: '',
              nwt: '',
              rate: '',
              netWithWastage: '',
              amount: '',
              netAmount: '',
              itemName: '',
              wtInTola: '',
              pureWeight: '',
            },
          ]);
          setGlobalDividerTitle('Update Quotation');
          let headerData = await response?.data?.summaryData;
          setBillNumber(headerData);
          setReceiptTotalAmt(headerData?.voucherAmount);
          setPurchaseNetAmount(Number(headerData?.purchaseAmount) || 0);
          setReceiveFromPartyNetAmount(Number(headerData?.receiveAmount) || 0);
          setSelectedDataSo((prev) => ({
            ...prev,
            ledger: headerData?.ledgerId,
            entryNumber: headerData?.referenceNumber || '',
            entryDate: dayjs(headerData?.orderDate),
            billNumber: headerData?.billNumber,
            agentId: headerData?.agentId,
            discountAmount: headerData?.discountAmount || 0,
            remarks: headerData?.remarks || '',
            ...(headerData?.storeId && { storeId: headerData?.storeId }),
            ...(!headerData?.storeId &&
              app?.stores?.length > 0 && {
                storeId: app.stores[0].referenceId,
              }),
          }));

          setSalesOrderSelectedData((prev) => ({
            ...prev,
            ledger: headerData?.ledgerId,
            entryNumber: headerData?.referenceNumber || '',
            entryDate: dayjs(headerData?.orderDate),
            billNumber: headerData?.billNumber,
            agentId: headerData?.agentId,
            discountAmount: headerData?.discountAmount || 0,
            remarks: headerData?.remarks || '',
            ...(headerData?.storeId && { storeId: headerData?.storeId }),
            ...(!headerData?.storeId &&
              app?.stores?.length > 0 && {
                storeId: app.stores[0].referenceId,
              }),
          }));
          const voucherData = response?.data?.summaryData?.voucherData;

          if (voucherData?.voucherEntries?.length) {
            const updatedDataSource = voucherData?.voucherEntries
              ? voucherData?.voucherEntries
                  ?.filter(
                    (detail) =>
                      parseFloat(detail.creditAmount.toString()) === 0,
                  )
                  .map((detail, index) => {
                    return {
                      key: index,
                      receiveTo: detail.ledgerId,
                      remarks: detail.remarks ? detail.remarks : '',
                      amount: parseFloat(detail.debitAmount.toString()),
                    };
                  })
              : [
                  {
                    key: 0,
                    receiveTo: null,
                    amount: 0,
                    remarks: null,
                  },
                ];
            // const remarks = voucherData?.voucherEntries
            //   ? voucherData?.voucherEntries
            //       ?.filter(
            //         (detail) =>
            //           parseFloat(detail.creditAmount.toString()) !== 0,
            //       )
            //       .map((detail) => detail.remarks)[0]
            //   : '';
            const remarks = voucherData?.narration || '';
            setReceiptVoucherHeader({
              ...receiptVoucherHeader,
              voucherNo: voucherData?.voucherNo,
              voucherDate: voucherData?.voucherDate,
              voucherId: voucherData?.referenceId,
              remarks: remarks,
            });
            setDataSource(updatedDataSource);
          } else {
            const latestVoucher = await ShowAllData.showDetails(
              '/vouchers/receipts/fetch-voucher-number/',
              navigate,
            );
            setReceiptVoucherHeader({
              ...receiptVoucherHeader,
              voucherNo: latestVoucher?.data?.voucherNumber,
            });
          }
        }
        if (!id && !editApiBlock) {
          const defaultStoreId =
            app?.stores?.length > 0 ? app.stores[0].referenceId : null;
          const response = await ShowAllData.showDetails(
            defaultStoreId
              ? `/transaction/quotation/latest-bill-number/?storeId=${defaultStoreId}`
              : '/transaction/quotation/latest-bill-number/',
          );
          setGlobalDividerTitle('Create Quotation');
          setBillNumber(response);
          setReceiptTotalAmt(0);
          setSelectedDataSo((prev) => ({
            ...prev,
            billNumber: response?.billNumber,
            entryDate:
              app?.financialEndYear &&
              new Date(getTodaysDateMYD()) > new Date(app?.financialEndYear)
                ? dayjs(app?.financialEndYear)
                : selectedDataSo?.entryDate || getTodaysDate(),
            deliveryDate: selectedDataSo?.deliveryDate || getTodaysDate(),
            ...(defaultStoreId && { storeId: defaultStoreId }),
          }));

          setSalesOrderSelectedData((prev) => ({
            ...prev,
            billNumber: response?.billNumber,
            entryDate:
              app?.financialEndYear &&
              new Date(getTodaysDateMYD()) > new Date(app?.financialEndYear)
                ? dayjs(app?.financialEndYear)
                : salesOrderSelectedData?.entryDate || getTodaysDate(),
            deliveryDate:
              salesOrderSelectedData?.deliveryDate || getTodaysDate(),
            ...(defaultStoreId && { storeId: defaultStoreId }),
          }));

          setPreviousPath('/sales/quotation/create/');
          const latestVoucher = await ShowAllData.showDetails(
            '/vouchers/receipts/fetch-voucher-number/',
            navigate,
          );
          setReceiptVoucherHeader({
            ...receiptVoucherHeader,
            remarks: null,
            voucherNo: latestVoucher?.data?.voucherNumber,
          });
        }
        fetchItemList();
        fetchPartyList();
      } finally {
        setLoading(false);
        setShowSalesDescription(false);
      }
    };
    fetchData();
  }, []);

  const fetchItemList = async () => {
    const itemResponse = await ShowAllData.showDetails(
      `/account/inventory/items/?groupIds=${groupIds?.join(',')}&categoryIds=${categoryIds?.join(',')}`,
    );
    setShowItemList(itemResponse.data);
  };

  const fetchPartyList = async () => {
    setFrom('sales-order');
    const partyListResponse = await ShowAllData.showDetails(
      '/account/ledgers/purchase-receive/',
    );
    const agentListResponse = await ShowAllData.showDetails(
      '/account/ledger/agent/',
    );
    setAgentList(agentListResponse.data);
    setShowPartyList(partyListResponse.data);
  };

  /**
   * Sets the form fields value based on selected data.
   */

  useEffect(() => {
    const fetchSelectedData = () => {
      form.setFieldsValue(selectedDataSo);
    };
    fetchSelectedData();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      ...selectedDataSo,
      entryDate:
        selectedDataSo?.entryDate &&
        app?.financialEndYear &&
        new Date(selectedDataSo.entryDate) > new Date(app.financialEndYear)
          ? dayjs(app.financialEndYear)
          : selectedDataSo?.entryDate,
      entry_date_bs:
        selectedDataSo?.entryDate &&
        app?.financialEndYear &&
        new Date(selectedDataSo.entryDate) > new Date(app.financialEndYear)
          ? getBsFromAD(app.financialEndYear)
          : getBsFromAD(selectedDataSo?.entryDate),
    });
  }, [selectedDataSo]);

  const fetchedReceiveApiData = () => {
    handleVoucherFetchApiClicked({
      ledgerUrl: '/vouchers/receipt-ledgers/',
      voucherUrl: '/vouchers/receipts/fetch-voucher-number/',
      setBillNumber,
      selectedData: selectedDataSo,
      setCashBankLedgerData,
      setReceiveModalVisible,
    });
  };

  const selectRefs = useRef([]);

  const selectRef = useRef(null);
  const agentRef = useRef(null);

  useEffect(() => {
    const purchaseTableDataLength = salesOrderTableData?.length - 1;
    if (purchaseTableDataLength >= 1) {
      selectRefs?.current[purchaseTableDataLength]?.current?.focus();
    } else if (isCancel === 'cancel') {
      selectRefs.current[record?.index]?.current?.focus();
    }
  }, [addRow, selectRefs]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'F10') {
      e.preventDefault();
      form?.submit();
    }
  }, []);

  useEffect(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const history = useNavigationHistory();

  const target = [...history]
    ?.reverse()
    ?.find(
      (path, index) =>
        index === 1 && returnLinks?.some((prefix) => path?.startsWith(prefix)),
    );

  const { isDL } = useDeviceInfo();

  const salesOrderModifiedData = taxVat?.isTaxApplicable
    ? salesOrderTableData
    : salesOrderTableData?.map((item) => ({
        ...item,
        taxPercent: 0,
      }));

  const result2 = calculateSalesAmountsWithTaxVat(
    salesOrderModifiedData,
    salesOrderSelectedData?.discountAmount || 0,
    0,
  );

  const salesOrderDataToUse = taxVat?.isTaxApplicable
    ? result2?.dataWithTaxAmount
    : result2?.dataWithTaxAmount;

  const netAmountFixed = parseFloat(
    calculateTotal(salesOrderTableData, 'netAmount') -
      (salesOrderSelectedData?.discountAmount || 0) -
      +result2?.totalVatAmount +
      result2?.totalTaxAmount,
  )?.toFixed(3);

  useEffect(() => {
    if (salesOrderTableData?.length > 1) {
      form.setFieldsValue({
        discount_amount: salesOrderSelectedData?.discountAmount || 0,
      });
    }
  }, [
    salesOrderTableData,
    purchaseNetAmount,
    salesOrderSelectedData,
    receiveTableData,
    taxVat,
  ]);

  useEffect(() => {
    form.setFieldValue('inputtedNetAmount', netAmountFixed);
  }, [salesOrderSelectedData?.discountAmount, salesOrderTableData, taxVat]);

  const calaculatedTaxableAmount = (
    Number(totalAmount) - form.getFieldValue('discount_amount') || 0
  ).toFixed(3);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Back />
        <GlobalDivider
          name={params?.id ? 'Update Sales Quotation' : 'Create Quotation'}
        />
      </div>
      <Form
        form={form}
        onFinish={handleSubmit}
        onValuesChange={(changedValues) => {
          if (changedValues) {
            setHiddenValueChange(true);
          }
        }}
      >
        <Form.Item name="hidden_valueChange" hidden>
          <Input />
        </Form.Item>
        <DynamicTransactionHeader
          hanldeInputData={hanldeInputData}
          showPartyList={showPartyList}
          billNumber={billNumber}
          selectedData={selectedDataSo}
          refreshTable={fetchPartyList}
          agentList={agentList}
          // from="order"
          selectRef={selectRef}
          selectRefs={selectRefs}
          agentRef={agentRef}
        />
        <DynamicTransactionTableSO
          loading={loading}
          columns={SALES_ORDER_COLUMNS_NEW}
          tableData={salesOrderDataToUse}
          handleAddRow={handleAddRow}
          selectRefs={selectRefs}
          selectRef={selectRef}
          purchaseTableData={purchaseTableData}
          handleItemSelect={handleItemSelect}
          renderSummary={renderTransactionTableSummarySalesI(
            salesOrderTableData,
          )}
          showItemList={showItemList}
          baseUrl="transaction/sales/quotation/create"
          editUrl="transaction/sales/quotation/edit"
          handlePurchaseItemClick={handleSalesOrderItemClicked}
          refreshTable={fetchItemList}
        />

        <div className="tw-pl-[15px] tw-fixed tw-bottom-0 tw-w-[95%]  lg:tw-w-[95%]">
          <div>
            <Form.Item label="Remarks" name="remarks">
              <Input.TextArea
                placeholder="Enter Remarks"
                rows={1}
                className="tw-w-[150px] md:tw-w-[200px] lg:tw-w-[300px] 2xl:tw-w-[400px]"
              />
            </Form.Item>
          </div>
          <div
            style={{
              fontSize: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '15px 0px',
            }}
          >
            <div></div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                clear: 'both',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  float: 'right',
                }}
              >
                <Card
                  styles={{
                    body: {
                      padding: '6px 12px',
                      margin: 0,
                    },
                  }}
                >
                  <div className="tw-flex tw-justify-between tw-gap-x-5">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: isDL ? '0px' : '4px',
                        borderRadius: '8px',
                        width: '300px',
                      }}
                    >
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: isDL ? 12 : 14,
                          }}
                        >
                          Sub Total :
                        </div>
                        <div style={{}}>
                          <strong>
                            {formatNumberWithComma(Number(totalAmount))}
                          </strong>
                        </div>
                      </div>
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />

                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: 14,
                          }}
                        >
                          Discount :
                        </div>
                        <Form.Item name={'discount_amount'} noStyle>
                          <InputNumber
                            ref={discountRef}
                            style={{ textAlign: 'right' }}
                            value={salesOrderSelectedData?.discountAmount}
                            onChange={(value) => {
                              const parsedValue = toDecimal(value || 0);

                              setSalesOrderSelectedData((prev) => ({
                                ...prev,
                                discountAmount: value,
                              }));

                              const totalNetAmount = toDecimal(
                                calculateTotal(
                                  salesOrderTableData,
                                  'netAmount',
                                ),
                              ).minus(purchaseNetAmount);

                              const itemsWithDiscount = salesOrderTableData.map(
                                (item) => {
                                  const purchaseAmount = toDecimal(
                                    item?.purchaseAmount || 0,
                                  );
                                  const netAmount = toDecimal(
                                    item?.netAmount || 0,
                                  ).minus(purchaseAmount);

                                  const discountRatio = totalNetAmount.isZero()
                                    ? new Decimal(0)
                                    : netAmount.dividedBy(totalNetAmount);
                                  const discountAmount = roundTo3(
                                    discountRatio.times(parsedValue),
                                  );

                                  return {
                                    ...item,
                                    discountAmount,
                                  };
                                },
                              );

                              setSalesOrderTableData(itemsWithDiscount);

                              form.setFieldValue(
                                'inputtedNetAmount',
                                parseFloat(
                                  calculateTotal(
                                    salesOrderTableData,
                                    'netAmount',
                                  ) -
                                    parsedValue -
                                    result2?.totalVatAmount +
                                    result2?.totalTaxAmount,
                                )?.toFixed(3),
                              );
                            }}
                            onPressEnter={(e) => {
                              e.preventDefault();
                              buttonRef.current?.focus();
                            }}
                            controls={false}
                          />
                        </Form.Item>
                      </div>

                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />

                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: 14,
                          }}
                        >
                          Taxable Amount :
                        </div>
                        <div>
                          <strong>{Number(calaculatedTaxableAmount)}</strong>
                        </div>
                      </div>
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />

                      <div
                        style={{
                          display: app?.isTaxApplicable ? 'flex' : 'none',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: 14,
                          }}
                        >
                          <Form.Item noStyle name={'tax_percent'}>
                            <Checkbox
                              style={{
                                marginRight: '5px',
                              }}
                              checked={taxVat?.isTaxApplicable}
                              onChange={(e) => {
                                const text = e?.target?.checked;
                                setTaxVat({
                                  ...taxVat,
                                  isTaxApplicable: text,
                                  tax_percent: text,
                                });
                              }}
                            >
                              {`${app?.taxLabelName}` || 'Luxury Tax @'}
                              {app?.luxuryTaxPercent}% :
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div>
                          <strong>
                            {formatNumberWithComma(
                              result2?.totalTaxAmount ?? 0,
                            )}
                          </strong>
                        </div>
                      </div>

                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />

                      <div
                        style={{
                          display: app?.isVatApplicable ? 'flex' : 'none',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: 14,
                          }}
                        >
                          <Form.Item noStyle name={'tax_percent'}>
                            <Checkbox
                              style={{
                                marginRight: '5px',
                              }}
                              checked={true}
                              onChange={(e) => {
                                const text = e?.target?.checked;
                                setTaxVat({
                                  ...taxVat,
                                  isVatApplicable: text,
                                });
                              }}
                            >
                              VAT @13% :
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div>
                          <strong>{result2?.totalVatAmount ?? 0}</strong>
                        </div>
                      </div>
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                        className="transaction-table-calculation-list"
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            color: '#5c5c5c',
                            fontSize: 14,
                          }}
                        >
                          Net Amount :
                        </div>
                        <strong>
                          <Form.Item name={'inputtedNetAmount'} noStyle>
                            <InputNumber
                              style={{ textAlign: 'right' }}
                              onChange={async (e) => {
                                const enteredValue = Number(e ?? 0);

                                const salesNetAmount = parseFloat(
                                  calculateTotal(
                                    salesOrderTableData,
                                    'netAmount',
                                  ),
                                );

                                const taxRate =
                                  Number(app?.luxuryTaxPercent || 0) / 100 || 0;

                                const vatRate =
                                  Number(app?.vatPercent || 0) / 100 || 0;
                                const combinedRate = taxVat?.isTaxApplicable
                                  ? 1 + taxRate
                                  : 0;

                                const totalDsPerRow =
                                  salesOrderTableData.reduce((sum, item) => {
                                    const rowDsAmount = (
                                      item?.finalData?.diamondStoneJson ||
                                      item?.diamondStones ||
                                      []
                                    ).reduce(
                                      (acc, stone) => acc + (stone.amount || 0),
                                      0,
                                    );
                                    return sum + rowDsAmount;
                                  }, 0);

                                const reverseVatAmount = roundTo3(
                                  totalDsPerRow * vatRate,
                                );

                                const adjustedNetAmount =
                                  enteredValue - reverseVatAmount;
                                const reverseTaxableAmount =
                                  combinedRate > 0
                                    ? adjustedNetAmount / combinedRate
                                    : adjustedNetAmount;

                                const reverseDiscountAmount = parseFloat(
                                  salesNetAmount - reverseTaxableAmount,
                                )?.toFixed(3);

                                form.setFieldsValue({
                                  discount_amount: Number(
                                    reverseDiscountAmount,
                                  ),
                                });
                              }}
                              onPressEnter={(e) => {
                                e.preventDefault();
                                buttonRef.current?.focus();
                              }}
                              controls={false}
                            />
                          </Form.Item>
                        </strong>
                      </div>
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                        }}
                      />
                    </div>
                  </div>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <VoucherFooterButton
                    id={id}
                    path="/transaction/quotation/list/"
                    loading={isPending || updateData?.isPending}
                    handleModalClose={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>

      <DraggableModal
        open={modalPurchase}
        setOpen={() => {}}
        width={'95%'}
        onCancel={() => {
          setModalPurchase(false);
          // navigate(-1);
        }}
        title={<div>{'Quick Purchase'}</div>}
        footer={null}
      >
        <QuickPurchase />
      </DraggableModal>

      {receiveModalVisible && (
        <SalesReceiptModal
          visible={receiveModalVisible}
          onTotalUpdate={() => {}}
          onClose={() => setReceiveModalVisible(false)}
          selectedData={selectedDataSo}
          billNumber={billNumber}
          dataSource={dataSource}
          setDataSource={setDataSource}
          receiptVoucherHeader={receiptVoucherHeader}
          setReceiptVoucherHeader={setReceiptVoucherHeader}
          cashBankLedgerData={cashBankLedgerData}
          refreshTable={fetchedReceiveApiData}
        />
      )}
      <TransactionSubmitModal
        hideBarCode={true}
        visible={barCodeVisible}
        onClose={() => {
          if (target) {
            closeBarCodeModal();
            return;
          } else {
            navigate('/transaction/quotation/list/');
          }
        }}
        onSave={handleSubmit}
        barcodeValues={barcodeValue}
        billTemplateData={defaultTemplateToPrint || data?.data?.[0]}
        tableData={salesOrderTableData?.map((row) => ({
          ...row,
          itemCode: row.code || row.itemCode,
          netWithWastage:
            row.netWithWastage || row?.summaryData?.netWithWastage,
        }))}
        columns={filterColumnforBillPrint}
        title={'Quotation'}
        party={
          showPartyList?.find(
            (item) => item.referenceId === selectedDataSo?.ledger,
          )?.name || selectedDataSo?.ledgerName
        }
        billNumber={selectedDataSo?.billNumber || selectedDataSo?.billNo}
        voucherNumber={selectedDataSo?.entryNumber}
        date={form?.getFieldValue('entryDate')?.format('YYYY-MM-DD')}
        from="transaction"
        extraDetails={extraDetails}
        setExtraDetails={setExtraDetails}
        navigate={() => navigate('/transaction/quotation/list/')}
      />
    </div>
  );
};

export default SalesQuotation;
